<template>
  <v-app id="inspire">
    <v-content>
      <v-container fluid fill-height>
        <v-layout >
          <v-flex xs12 sm6 offset-sm3>
            <p class="display-1 text-no-wrap text-md-center font-weight-thin font-italic"></p>
            <v-card>
              <v-img
                src="https://storage.googleapis.com/spitzer-risc-logos/new-clinic.png"
              ></v-img>
              <div class="backgroud-logo logo">
              </div>
              <v-card-title primary-title>
                <v-card-text>
                  <p class="text-xs-center title primary--text">Recuperação de senha</p>

                  <p class="text-xs-center title primary--text">
                    Para recuperar sua senha de acesso, informe no campo abaixo o email utilizado no cadastro.
                  </p>
              <v-form action="#" v-model="valid" ref="form" lazy-validation @submit.prevent="submit()">
                <v-text-field
                  label="E-Mail"
                  v-model="auth.username"
                  :rules="[v => !!v || 'Informe o e-mail cadastrado!']" required
                ></v-text-field>

                <v-btn
                  :color="this.getTheme.color"
                  dark
                  block
                  @click="submit()"
                >
                  Recuperar Senha
                </v-btn>
                <br><hr><br>
                <router-link to="/patient/login">
                  <v-btn block>Retornar para Login</v-btn>
                </router-link>

              </v-form>

              </v-card-text>
              </v-card-title>
              <v-card-actions>
                <div>
                  <p>© 2017 - {{ new Date().getFullYear() }} <a href="http://www.spitzer.io">Spitzer.io</a> - Todos os direitos reservados</p>
                  <p>Versão: {{getPkg.pkg.version}}</p>
                </div>

              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
        <v-snackbar
          :timeout="snackbarConfig.timeout"
          :color="snackbarConfig.color"
          :multi-line="snackbarConfig.mode === 'multi-line'"
          :vertical="snackbarConfig.mode === 'vertical'"
          v-model="snackbarConfig.snackbar"
        >
          {{ snackbarConfig.text }}
          <v-btn dark flat @click.native="snackbarConfig.snackbar = false">Fechar</v-btn>
        </v-snackbar>
      </v-container>
    </v-content>
  </v-app>
</template>


<script>
  import axios from 'axios'
  // import localforage from 'localforage'
  import { mapGetters } from 'vuex'

  export default {
    name: 'Reset-password',
    computed: {
      ...mapGetters({
        customer: 'customer'
      }),
      ...mapGetters('app', ['getTheme', 'getPkg']),
      progress () {
        return Math.min(100, this.auth.password.length * 10)
      },
      color () {
        return ['error', 'warning', 'success'][Math.floor(this.progress / 40)]
      }
    },
    mounted () {
    },
    data: () => ({
      env: process.env.URL,
      snackbarConfig: {
        snackbar: false,
        color: 'error',
        mode: '',
        timeout: 6000,
        text: 'Erro de conexão com o servidor!'
      },
      valid: true,
      e1: true,
      p1: true,
      custom: true,
      auth: {
        username: ''
      }
    }),
    methods: {
      changeCssColor () {
      },
      changeLogo () {
      },
      changeColorHTML () {
      },
      submit () {
        if (this.$refs.form.validate()) {
          axios.post(process.env.URL + '/my-clinic-new/auth/forget-password', {
            username: this.auth.username
          }).then((response) => {
            this.$router.push('/')
          }).catch((err) => {
            if (err.response.data.message) {
              this.snackbarConfig.snackbar = true
              this.snackbarConfig.text = err.response.data.message
              return false
            }
            if (err.response.data.errors) {
              if (err.response.data.errors.username) {
                this.snackbarConfig.snackbar = true
                this.snackbarConfig.text = err.response.data.errors.username.msg
                return false
              }
            }
            this.snackbarConfig.snackbar = true
            this.snackbarConfig.text = err.response.data.result.error
          })
        }
      }
    }
  }
</script>





// WEBPACK FOOTER //
// src/views/auth/Forget-password.vue